import React from "react";
import { useModal } from "../contexts/ModalContext";
import FormularioRD from "../rdstation/formularioRD";

const MaximaSeguranca = ({
    backgroundImage,
    text,
    buttonText,
    buttonTextColor,
    buttonLink,
}) => {
    const { openModal } = useModal();
    return (
        <div className="relative w-full bg-[#040116] overflow-hidden py-16 px-8">
            {/* Background image container with fixed positioning */}
            <div className="absolute inset-0 w-full h-full overflow-hidden">
                <div className="w-full h-full flex items-center justify-center">
                    <img
                        src={backgroundImage}
                        alt="Background"
                        className="w-full h-full object-cover object-center min-w-[100%] min-h-[100%]"
                    />
                </div>
            </div>

            {/* Blur effect */}
            <div
                className="absolute inset-0 blur-3xl w-[80%] mx-auto left-0 right-0 mt-16 rounded-full opacity-80"
                style={{ backgroundColor: "#000" }}
            />

            {/* Content container with fixed width and centered positioning */}
            <div className="relative z-10 container mx-auto px-2 md:px-4 max-w-6xl text-center">
                <h2 className="font-inter-regular text-white text-4xl md:text-5xl mb-6 mx-auto leading-11 md:leading-14">
                    {text}
                </h2>

                {/* Button */}
                <div className="mt-16">
                    <button
                        onClick={() => openModal(<FormularioRD />)}
                        className="text-xl inline-block bg-white font-inter-medium py-4 md:py-3 px-6 md:px-8 rounded-full transition-all duration-300 cursor-pointer hover:scale-105"
                        style={{ color: buttonTextColor }}
                    >
                        {buttonText}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default MaximaSeguranca;
